// Utility functions for formatting and data conversion

export function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + "K";
  }
  return num.toString();
}

export function formatPercentage(num) {
  return num.toFixed(1) + "%";
}

export function formatDate(date) {
  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

// Convert brand comparison data to percentages
export function convertBrandDataToPercentage(data, valueKey) {
  const total = data.reduce((sum, item) => sum + (item[valueKey] || 0), 0);
  if (total === 0) return data;

  return data.map(item => ({
    ...item,
    [valueKey]: ((item[valueKey] || 0) / total) * 100,
    [`${valueKey}Absolute`]: item[valueKey] || 0, // Store original value
  }));
}

// Convert grouped bar chart data to percentages (row-based)
export function convertGroupedDataToPercentage(data, brandKeys) {
  return data.map(row => {
    // Calculate total for this row
    const total = brandKeys.reduce((sum, brand) => sum + (row[brand] || 0), 0);
    if (total === 0) return row;

    // Convert each brand value to percentage
    const percentageRow = { ...row };
    brandKeys.forEach(brand => {
      percentageRow[`${brand}Absolute`] = row[brand] || 0; // Store original
      percentageRow[brand] = ((row[brand] || 0) / total) * 100;
    });

    return percentageRow;
  });
}

export const getBrandColor = (index) => {
  const colorMap = {
    0: '#f9a620',
    1: '#ffd449',
    2: '#aab03c',
    3: '#548c2f',
    4: '#000000',
    5: '#1A9AB0',
  };
  return colorMap[index] || colorMap[0];
};